exports.IsAdmin =  function IsAdmin() {
    if (process.env.NODE_ENV === 'development') {
        return true;
    }
    return localStorage.getItem("userRole") === "Admin";
}

exports.GetRole =  function GetRole() {
    if (process.env.NODE_ENV === 'development') {
        return "Admin";
    }
    return localStorage.getItem("userRole");
}

exports.GetEmail =  function GetEmail() {
    if (process.env.NODE_ENV === 'development') {
        return "user@email.com";
    }
    return localStorage.getItem("userEmail");
}